export default __webpack_public_path__ + "static/media/petInsurance.7db8b4a3.svg";